import { Fragment } from 'react';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PendingApprovalButtonI18nTitleApproversList(props) {
  const {
    approval
  } = props;
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: "100",
    as: "span",
    children: approval.data.approvalSteps.map((approvalStep, index) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ApprovalUserFormattedName, {
        approvalUser: approvalStep.approver
      }), index < approval.data.approvalSteps.length - 1 && ', ']
    }, approvalStep.id))
  });
}
export default PendingApprovalButtonI18nTitleApproversList;